export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'FR',
  'merchantReturnLink': 'https://www.timberland.fr/fr-fr/aide-et-contact/retours',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
